export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.f590267dc7e2adb0f4059ccf28d6d042.css";